// updates data to send values based on each input change
import { AxiosInstance } from "axios";
import { NavigateFunction } from "react-router-dom";
import { toast } from "react-toastify";
import { Predicates } from "../../../libraries/predicates/predicates";
import { MasterArtworkCollectionActions } from "../../../states/meta-artwork/collections";
import { MasterArtworkNameActions } from "../../../states/meta-artwork/artwork-name";
import { MasterArtworkNumberActions } from "../../../states/meta-artwork/artwork-number";
import { MasterArtworkPrintingTechniqueActions } from "../../../states/meta-artwork/printing-technique";

export enum actionsList {
  "CREATED" = "CREATED",
  "SUBMITTED" = "SUBMITTED",
  "REJECTED" = "REJECTED",
  "APPROVED" = "APPROVED",
  "EDITED" = "EDITED",
  "SELECTED" = "SELECTED",
  "DELETED" = "DELETED",
}

type ValueOrNull<T> = T | null;

export function processRequestErrorIntoErrorToast(error: any) {
  const errorMessages = Object.values(error.response.data).flat() as string[];
  errorMessages.length > 0 && errorMessages.length < 10
    ? errorMessages.forEach((errorMessage) => toast.error(errorMessage))
    : toast.error("An unknown error occurred. Contact support.");
}

export const saveRequest = (x: any, c: any, v: any, b: any, n: any) => {};

export interface IGenericRequest {
  requestId: any | null;
  action: keyof typeof actionsList;
  action_user: string;
  context: number;
  country: number;
  data: string;
  reason: ValueOrNull<number>;
  comment: string;
}

export const submitPrintingTechniqueRequest = async (
  axios: AxiosInstance,
  request: IGenericRequest,
  username: string,
  dispatch: any,
  setIsInProgress: (isLoading: boolean) => void,
  navigate: NavigateFunction,
  navigateUrl: string,
  navigateReplace: boolean,
  image?: any,
) => {
  const requestHasId = Predicates.isNotNullAndNotUndefinedAndNotEmpty(
    request.requestId?.toString(),
  );
  try {
    setIsInProgress(true);

    const formData = new FormData();
    formData.append('image', image)
    formData.append("action", actionsList[request.action])
    formData.append("action_user", username)
    formData.append("context", `${request.context}`)
    formData.append("data", request.data);
    formData.append("country", `${request.country}`)
    formData.append("comment", request.comment)
    formData.append("reason", `${request.reason}`);

    const url = !!request.requestId ? `/artwork/printing-technique/${request.requestId}/` : '/artwork/printing-technique/'

    const response = await axios({
      method: !!request.requestId ? "patch" : 'post',
      url: url,
      data : formData
    });

    toast.success(`Request ${response.data.id} ${request.action} successfully`);

    setIsInProgress(false);
    navigate(`${navigateUrl}`, { replace: navigateReplace });
  } catch (err) {
    console.error(err);
    processRequestErrorIntoErrorToast(err);
    setIsInProgress(false);
  }
};

export const submitCollectionEditRequest = async (
  axios: AxiosInstance,
  id: string | number,
  data: any,
) => {
  const requestUrl = `artwork-master/collections/${id}/`;

  const collectionUpdateDTO = {
    // id: data.id,
    name: data.name,
    code: data.code,
    licensor: data.licensor.id,
    licensed_property: data.licensed_property.id,
    launch_date: data.launch_date,
    global_product: data.global_product,
  };


  const response = await axios({
    method: "patch",
    url: requestUrl,
    data: collectionUpdateDTO,
  })

  return response;
};
